export enum TASK_TYPE {
  PREFETCH_DATA = 'prefetchData',
  DEFERRED_DATA = 'deferredData'
}
